// extracted by mini-css-extract-plugin
export default {"button":"Counter_button__3p0uT","span":"Counter_span__8qK78"};